import { useEffect, useMemo } from 'react'
import { observer } from 'mobx-react-lite'
import { useParams } from 'react-router-dom'
import { useLocation } from 'react-router'
import { uiStore } from 'shared/store/uiStore'
import { stringToNumber } from 'shared/lib/stringToNumber'
import { layoutStore } from 'shared/layout'
import { useEntitiesContext } from 'entities/EntitiesExport'
import {
  ProviderProfilePage,
  useProfilePageContext,
} from 'pages/conversations/pages/search/pages/profile/context/profileContext'
import { ProfilePageStore } from 'pages/conversations/pages/search/pages/profile/store/profilePageStore'
import { HeaderProfile } from 'pages/conversations/pages/search/pages/profile/ui/HeaderProfile/HeaderProfile'
import { useProfileLayoutPageContext } from 'pages/conversations/pages/search/pages/profile/context/profileLayoutContext'
import { ConversationsPath } from 'pages/conversations/route/conversationsPath'
import { SectionConversation } from 'pages/conversations/pages/search/pages/profile/ui/SectionConversation'
import { SectionMessages } from 'pages/conversations/pages/search/pages/profile/ui/SectionMessages'
import { SectionContactDetails } from 'pages/conversations/pages/search/pages/profile/ui/SectionContactDetails'
import { BreakpointsSearchPageProfileEnum } from 'pages/conversations/pages/search/pages/profile/constants/breakpoints'
import styles from './styles.module.scss'

const ProfilePageContent = observer(() => {
  const store = useProfilePageContext()
  const params = useParams()
  const conversationId = stringToNumber(params?.conversationId)

  useEffect(() => {
    layoutStore.setBreakpoints(BreakpointsSearchPageProfileEnum)

    return () => {
      layoutStore.setDefault()
    }
  }, [])

  useEffect(() => {
    if (typeof conversationId === 'number') {
      store.sectionConversationStore.setCurrentItemId(conversationId)
    }
  }, [conversationId])

  return (
    <div className={styles.wrap}>
      <HeaderProfile />
      <div className={styles.container}>
        <SectionConversation store={store.sectionConversationStore} />
        <SectionMessages store={store.sectionMessagesStore} />
        <SectionContactDetails store={store.sectionContactDetailsStore} />
      </div>
    </div>
  )
})

export const ProfilePage = observer(() => {
  const { search } = useLocation()
  const query = new URLSearchParams(search)
  const storeLayout = useProfileLayoutPageContext()
  const entities = useEntitiesContext()
  const store = useMemo(() => {
    if (!storeLayout.readyIsNext) return null
    if (!storeLayout.contact) return null

    return new ProfilePageStore(
      storeLayout.contact,
      storeLayout.conversation,
      storeLayout.messageId,
      storeLayout.limit,
      entities
    )
  }, [storeLayout.contact, storeLayout.conversation, storeLayout.readyIsNext, storeLayout.limit])

  useEffect(() => {
    if (!store) {
      query.delete('contactId')
      query.delete('messageId')

      uiStore.changeRoute({
        path: `/${ConversationsPath.search}`,
        query: query.toString(),
      })
    }
  }, [store])

  if (!store) return null

  return (
    <ProviderProfilePage value={store}>
      <ProfilePageContent />
    </ProviderProfilePage>
  )
})
